<!--
  ~ Copyright (c) by INFODATA-GROUP. All rights reserved.
  ~ No part of this publication may be reproduced, distributed,
  ~ or transmitted in any form or by any means, including photocopying, recording,
  ~ or other electronic or mechanical methods, without the prior written permission of the publisher,
  ~ except in the case of brief quotations embodied in critical
  ~ reviews and certain other noncommercial uses permitted by copyright law.
  ~  author : vhe
  ~  date : 02/03/2021 07:39
  -->

@if (resources()) {
  <div class="planning">
    @if (showResources()) {
      <infl-calendar-horizontal-resources
        #resourcesComponent
        [resources]="resources()"
        [resourceTitle]="resourceTitle()"
        [heightTitle]="60"
        (changeDisplay)="generateTasks()"
      ></infl-calendar-horizontal-resources>
    }
    <div class="calendar" [ngClass]="{ onWeek: onWeek() }">
      <div class="header" [ngClass]="{ onWeek: onWeek() }" [style.background-color]="backgroundColorDay()">
        @if (showResources()) {
          <div class="sub-header">
            <div class="header-content">SEMAINE {{ weekNumber() }}</div>
          </div>
        }
        <div #header class="sub-header">
          <div
            class="header-content"
            [style.font-weight]="isCurrentDay ? 'bold' : null"
            [innerHTML]="
              day()
                | customDate: 'DD/MM/YYYY' : translate.currentLang() : false
                | uppercase
            "
          ></div>
        </div>
      </div>
      <table #tableBody class="body" [style.width.px]="cellWidth()">
        @for (group of resources(); track group.id) {
          <tbody
            (mousemove)="onMouseMove($event)"
            (dragenter)="$event.preventDefault()"
            (dragover)="$event.preventDefault()"
            (dragleave)="onDragLeaveTbody()"
          >
            <tr class="group-header-row">
              <td [colSpan]="numberSection()"></td>
            </tr>
            @if (group.isOpened) {
              @for (subGroup of group.tasksGroups; track subGroup.id) {
                <tr class="section" [style.height.px]="subGroup.height">
                  <td>
                    <infl-calendar-section
                      #section
                      [canResize]="canResize()"
                      [canDrag]="canDrag()"
                      [canSelect]="canSelect()"
                      [height]="subGroup.height"
                      [taskHeight]="taskHeight()"
                      [section]="sections()[subGroup.id]"
                      [outsideDraggingTask]="draggingTask()"
                      [resources]="resources()"
                      [resource]="subGroup.id"
                      [dragByOutside]="dragByOutside()"
                      (taskUpdate)="taskUpdate.emit($event)"
                      (taskCreation)="taskCreation.emit($event)"
                      (dragTask)="onDragStart($event)"
                      (dropOutside)="taskDropped()"
                      (taskClick)="taskClick.emit($event)"
                      (taskDblClick)="taskDblClick.emit($event)"
                      (taskHover)="taskHover.emit($event)"
                      (hourSelection)="hourSelection.emit($event)"
                      (hourPreselection)="hourPreselection.emit($event)"
                      (lastSectionHighlighted)="sectionDragOver($event)"
                    ></infl-calendar-section>
                  </td>
                </tr>
              }
            }
          </tbody>
        }
      </table>
      <div class="tasks"></div>
    </div>
  </div>
}
